import React, { useEffect, useRef } from 'react';

function getYouTubeVideoID(url) {
  const regex =
    /https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
}

const YouTubePlayer = ({ width, height, trigger, url }) => {
  const playerRef = useRef(null);
  const playerInstance = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = loadPlayer;
    } else {
      loadPlayer();
    }
  }, []);

  useEffect(() => {
    if (playerInstance.current) {
      const iframe = playerInstance.current.getIframe();
      iframe.style.width = `${width}px`;
      iframe.style.height = `${height}px`;
    }
  }, [width, height]);

  const loadPlayer = () => {
    playerInstance.current = new window.YT.Player(playerRef.current, {
      height,
      width,
      videoId: getYouTubeVideoID(url),
      playerVars: {
        autoplay: 0,
        controls: 0,
        disablekb: 1,
        iv_load_policy: 3,
        loop: 1,
        modestbranding: 1,
        rel: 0,
      },
    });
  };

  const handlePlay = () => {
    if (triggerRef.current) {
      triggerRef.current.style.display = 'none';
    }

    if (playerInstance.current) {
      playerInstance.current.getIframe().style.display = 'block';
      playerInstance.current.unMute();
      playerInstance.current.playVideo();
    }
  };

  return (
    <div>
      <div ref={playerRef} style={{ borderRadius: '16px', display: 'none' }} />
      {trigger &&
        React.cloneElement(trigger, { onClick: handlePlay, ref: triggerRef })}
    </div>
  );
};

export default YouTubePlayer;
